export var ParticipantFilterOptionType;
(function (ParticipantFilterOptionType) {
    ParticipantFilterOptionType["Group"] = "group";
    ParticipantFilterOptionType["Teaching"] = "teaching";
    ParticipantFilterOptionType["Student"] = "student";
    ParticipantFilterOptionType["All"] = "all";
    ParticipantFilterOptionType["Staff"] = "staff";
    ParticipantFilterOptionType["Lecturer"] = "lecturer";
})(ParticipantFilterOptionType || (ParticipantFilterOptionType = {}));
